import { ViewContainer } from '@fortem-monorepo/react-spa'
import { ViewSectionTitle } from '@fortem-monorepo/react-spa'
import { ICReport } from '@fortem-monorepo/web-sdk'

import { ICReportWidget } from '@/pages/funds/ic-report/components/ICReportWidget'
import { useICStreamContext } from '@/pages/funds/ic-report/ic-report-context.context'
import { Section } from '@/pages/funds/ic-report/sections'

export interface ICReportSectionProps {
  section: Section
  params: Omit<ICReport.GetICReportDataParams, 'endpoint'>
}

export const ICReportSection: React.FC<ICReportSectionProps> = ({ section }) => {
  const { hasPrimitive, params } = useICStreamContext()

  return (
    <div className={'flex flex-col'}>
      <ViewSectionTitle
        className={'sticky top-12 z-30 bg-sidebar px-4 py-2 border-border border-b border-t'}
      >
        {section.sectionTitle}
      </ViewSectionTitle>
      <ViewContainer className={'flex flex-col gap-4'}>
        {section.children.map((child) => {
          const Component = child.component

          if (!hasPrimitive(child.key)) return null

          return child.unique ? (
            <div id={`icr_${child.key}`}>
              <Component params={params} key={child.key} />
            </div>
          ) : (
            <ICReportWidget widget={child} key={child.key} />
          )
        })}
      </ViewContainer>
    </div>
  )
}
